<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white pl-3">
        Dashboard </router-link>
      <span class="text-white"><i class="fa fa-ellipsis-v"></i> Exam Prep Exam</span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <modal :show.sync="modals.examModal" modal-classes="modal-dialog-centered modal-lg">
        <div class="card bg-secondary border-0 mb-0">
          <div class="card-body">
            <PageSpinner :onloader="onloader" />
            <form role="form">
              <div v-if="SchoolTypeIdval">
                <div class="row">
                  <div class="col-md-6">
                    <img v-if="ImgPathval" :src="ImgPathval" class="img-fluid" />
                    <img v-else src="/img/brand/empty.png" class="img-fluid" />
                  </div>
                  <div class="col-md-6">
                    <ImageUploader @emitOutImgPathval="updatePassportVal" />
                  </div>
                </div>
                <div class="form-group">
                  <label>Exam Name</label>
                  <input v-model="ExamNameval" class="form-control" />
                </div>
                <div class="form-group">
                  <label>Exam Code</label>
                  <input v-model="ExamCodeval" class="form-control" />
                </div>
                <div class="form-group">
                  <label>Default Number Of Question To Display</label>
                  <input v-model="NumberOfQuestionToDisplayVal" class="form-control" />
                </div>
                <div class="form-group">
                  <label>Default Time For The Exam</label>
                  <input v-model="TimeForTheExamVal" class="form-control" />
                </div>
              </div>
            </form>
          </div>
        </div>
        <template slot="footer">
          <base-button type="default" @click="modals.examModal = false">Cancel
          </base-button>
          <base-button type="success" @click.prevent="SubmitExam()">Submit
          </base-button>
        </template>
      </modal>
      <card header-classes="bg-transparent">
        <div>
          <div class="form-inline">
            <div class="input-group">
              <select v-model="SchoolTypeIdval" class="form-control" @change="GetExams()"
                :disabled="SchoolTypeItems === null">
                <option value="0">{{ SchoolTypeItems === null ? '⏳ Loading...' : '- Select School Type -'
                  }}</option>
                <option v-for="item in SchoolTypeItems" :key="item.schoolTypeId" v-bind:value="item.schoolTypeId">
                  {{ item.schoolTypeName }}
                </option>
              </select>

              <div class="input-group">
                <button class="btn btn-success mr-3" v-on:click="OpenExamModal()" v-if="SchoolTypeIdval">
                  <i class="fa fa-edit"></i> New
                </button>
              </div>
            </div>
            <div class="input-group" v-if="SchoolTypeIdval">
              <input v-model="searchval" class="form-control" @keyup="getsearch" placeholder="Search..." />
              <div class="input-group-append">
                <button type="button" @click.prevent="getsearch" class="btn btn-secondary">
                  <i class="fa fa-search"></i> Search
                </button>
              </div>
            </div>
          </div>
          <div class="mt-2">
            <transition name="fade">
              <list-skeleton v-if="!examitems" :rows="3" />
            </transition>
            <div class="row">
              <div class="col" v-for="item in examitems" :key="item.examId">
                <div class="card animate__animated animate__backInUp my-3">
                  <div class="card-body text-center">
                    <img v-if="item.examLogo" :src="item.examLogo" class="card-img-top" alt="" />
                    <img v-else src="img/brand/empty.png" class="card-img-top" alt="" />
                    <h5 class="mt-2">{{ item.examName }}</h5>
                    <div class="card-footer">
                      <button class="btn btn-secondary btn-sm my-2" v-on:click="GetExamById(item)">
                        <i class="fa fa-edit"></i> Edit
                      </button>
                      <button class="btn btn-default btn-sm" v-on:click="opensubject(item.examId)">
                        <i class="fa fa-list"></i> Exam Subject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner";
import ImageUploader from "@/components/ImageUploader"

export default {
  name: "ExamPrepExam",
  mixins: [Alert],
  components: {
    PageSpinner, ImageUploader
  },
  data() {
    return {
      accessDetails: null,
      ExamIdval: 0,
      SchoolTypeIdval: 0,
      ExamNameval: "",
      ExamCodeval: "",
      NumberOfQuestionToDisplayVal: 20,
      TimeForTheExamVal: 20,
      ImgPathval: "",
      examitems: null,
      SchoolTypeItems: null,
      file: "",
      uploadedimage: "",
      searchval: "",
      isModified: false,
      onloader: "none",
      modals: {
        examModal: false
      }
    };
  },
  methods: {
    OpenExamModal() {
      this.resetInput();
      this.modals.examModal = true
    },
    resetInput() {
      this.ExamNameval = "";
      this.ExamCodeval = "";
      this.ImagePathval = null;
      this.NumberOfQuestionToDisplayVal = 0;
      this.TimeForTheExamVal = 0;
      this.isModified = false;
    },
    opensubject(Id) {
      localStorage.setItem("ExamId", Id);
      this.$router.push("/admin/eduschool/eduschool-exam-prep/subject");
    },
    GetExamById(item) {
      this.onloader = "flex";
      this.ExamIdval = item.examId;
      this.ExamNameval = item.examName;
      this.ExamCodeval = item.examCode;
      this.ImgPathval = item.examLogo;
      this.NumberOfQuestionToDisplayVal = item.numberOfQuestionToDisplay;
      this.TimeForTheExamVal = item.timeForTheExam;
      this.isModified = true;
      this.onloader = "none";
      this.modals.examModal = true;
    },
    SubmitExam() {
      let SchoolTypeId = this.SchoolTypeIdval;
      let ExamName = this.ExamNameval;
      let ExamLogo = this.ImgPathval;
      let ExamId = this.ExamIdval;
      let ExamCode = this.ExamCodeval;
      let NumberOfQuestionToDisplay = this.NumberOfQuestionToDisplayVal;
      let TimeForTheExam = this.TimeForTheExamVal;
      let userdata = {};
      this.onloader = "flex";
      let operationVal = "";
      if (this.isModified == false) {
        operationVal = "ExamPrep/CreateExam";
        userdata = {
          SchoolTypeId,
          ExamName,
          ExamLogo,
          ExamCode,
          NumberOfQuestionToDisplay,
          TimeForTheExam
        }
      } else {
        operationVal = "ExamPrep/UpdateExam";
        userdata = {
          SchoolTypeId,
          ExamName,
          ExamLogo,
          ExamCode,
          NumberOfQuestionToDisplay,
          TimeForTheExam,
          ExamId
        }
      }
      this.$store
        .dispatch(operationVal, userdata)
        .then((resp) => {
          this.onloader = "none";
          if (resp.responseCode == '00') {
            this.GetExams();
            this.resetInput();
            this.modals.examModal = false;
            this.ShowAlertSuccess('Submitted successfully', '');
          } else {
            this.ShowAlertError(resp.responseMessage, '');
          }

        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, '');
        });
    },
    GetExams() {
      this.onloader = "flex";
      let SchoolTypeId = this.SchoolTypeIdval
      let userData = {
        SchoolTypeId
      }
      this.$store
        .dispatch("ExamPrep/GetExams", userData)
        .then((resp) => {
          this.examitems = resp.data;
          this.onloader = "none";
        })
        .catch((err) => {
          console.log(err);
          this.$store.dispatch("logout");
          this.onloader = "none";
          this.$router.push("/login");
        });
    },
    GetSchoolTypeForPortal() {
      this.onloader = "flex";
      this.$store
        .dispatch("SchoolType/GetSchoolTypeForPortal")
        .then((resp) => {
          this.SchoolTypeItems = resp.data;
          this.onloader = "none";
        })
        .catch((err) => {
          console.log(err);
          this.onloader = "none";
        });
    },
    getsearch() {
      this.$store
        .dispatch("getcbtexamsearch", this.searchval)
        .then((resp) => {
          this.examitems = resp;
        })
        .catch((err) => {
          this.ShowAlertError(err.response.data, '');
        });
    },
    updatePassportVal(data) {
      this.ImgPathval = data;
    },
  },
  mounted() {
    const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
    if (
      userDetails.isSuperAdmin == true ||
      userDetails.isAdmin == true ||
      userDetails.isSupportAdmin == true
    ) {
      this.GetSchoolTypeForPortal();
    } else {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    }
  },
};
</script>

<style></style>
